$(function () {
    "use strict";

  if (typeof theme != 'undefined') {
    theme.init();
  }

});

theme.init = function() {

  $('#updates_attributes_numar_telefon').change(function() {
        CartJS.setAttribute('numar_telefon', this.value);
  });

  if (Cookies != undefined) {
    theme.cookies();
  }
  if (theme.template.includes('product')) {
    theme.product();
    theme.quickProduct();
    theme.productActivityWidget();
  }
  theme.cartJs();
  theme.collapse();
  theme.megamenu();
  if (theme.template == 'index') {
    theme.homeSlideshow();
    theme.featureSlideshow();
    theme.recommendedSlideshow();
    theme.homeCollection();
    theme.blogArticles();
    theme.furnizori();
  }
  theme.accordion();
  if ($('.template-collection').length > 0 && $('.sort-by-box').length > 0) {
    theme.collectionSort();
  }
  theme.addToCart();
  theme.cartDrawer();
  theme.menuDrawer();
  theme.cartPage();
}

theme.cartDrawer = function() {
  theme.cartDrawer = new Canvi({
    content: '.canvi-content',
    navbar: '.mobile-offcanvas-cart',
    openButton: '.header-cart',
    position: 'right',
    pushContent: false
  });

  $('body').on('click tap', '.open-cart-drawer', function(e) {
    e.preventDefault();
    theme.cartDrawer.open();
  });
  $('body').on('click tap', '.header-cart', function(e) {
    e.preventDefault();
  })
  $('body').on('click tap', '#cart .close-drawer', function(e){
    e.preventDefault();
    theme.cartDrawer.close();
  });
}

theme.cartPage = function() {
  $('.page-cart #cart_agree').on('change invalid', function() {
      var textfield = $(this).get(0);
      textfield.setCustomValidity('');

      if (!textfield.validity.valid) {
        textfield.setCustomValidity('Pentru a continua trebuie sa fiti de acord');
      }
  });
}

theme.cartJs = function() {
  CartJS.init(theme.cart(), {
    "debug": false,
    "requestBodyClass": "loadingCart",
    "moneyFormat": $('body').data('cartjs-money-format'),
    "moneyWithCurrencyFormat": $('body').data('cartjs-money-with-currency-format')
  });
  rivets.bind(jQuery('.js-bind-rivets, .cart-quantity-indicator'), {cart: CartJS.cart});
}

$(document).on('cart.requestStarted', function(event, cart) {

});

$(document).on('cart.requestComplete', function(event, cart) {
  if (cart.item_count > 0) {
    $('body').addClass('has-items-in-cart');
  } else {
    $('body').removeClass('has-items-in-cart');
  }
});

$(document).on('cart.ready', function(event, cart) {
  $('body').removeClass('loadingCart');

  if (cart.item_count > 0) {
    $('body').addClass('has-items-in-cart');
  }
});

theme.productActivityWidget = function() {
  setTimeout(function(){
    var $widget = $('.product-activity-widget');
    if($widget.length > 0) {
      var d = new Date();
      var h = d.getHours();
      var nop = h > 22 || h < 9 ? Math.floor(Math.random() * 3) : Math.floor(Math.random() * 15);
      var persoane = nop === 1 ? ' persoană' : ' persoane';
      $widget.find('#number-of-people').empty().append(nop === 0 ? '1 persoană' : nop+persoane);
      $widget.show(200);
      setInterval(function(){
        var nopMultiplier = h > 22 || h < 9 ? Math.floor(Math.random() * 2) : Math.floor(Math.random() * 5);
        var randomActionIndicator = Math.floor(Math.random() * 2);
        var newnop = randomActionIndicator === 0 ? nop - nopMultiplier < 1 ? 1 : nop - nopMultiplier : nop + nopMultiplier;
        var persoane = newnop === 1 ? ' persoană' : ' persoane';
        $widget.find('#number-of-people').empty().append(newnop+persoane);
      }, 30000);
    }
  }, 30000);
}

theme.accordion = function() {
  $('body').on('click tap', '.accordion .toggle', function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
        $this.removeClass('active');
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.toggleClass('active');
        $this.parent().parent().find('li .ul').removeClass('show');
        $this.parent().parent().find('li .ul').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
  });
}

theme.collapse = function() {
  $('body').on('click', '.collapse', function() {
    $(this).parents('.collapse-item').toggleClass('open');
  })
}

theme.megamenu = function() {
  $('body').on('mouseenter', '.categorii', function() {
    if (!$('.template-index').length > 0) {
      $('.header-navigation').addClass('megamenu-open');
    }
  });

  $('body').on('mouseleave', '.header-navigation', function() {
    if (!$('.template-index').length > 0) {
      $('.header-navigation').removeClass('megamenu-open');
    }
  });
}

theme.homeSlideshow = function() {
  var swiper = new Swiper('.mobile-slideshow, .megamenu-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    passiveListeners: false,
    lazy: true,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.featureSlideshow = function() {
  var swiper = new Swiper('.features-content-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    passiveListeners: false,
    lazy: true,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.recommendedSlideshow = function() {
  var swiper = new Swiper('.recommended-collections-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.homeCollection = function() {
  var swiper = new Swiper('.collection-products-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.blogArticles = function() {
  var swiper = new Swiper('.blog-articles-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.furnizori = function() {
  var swiper = new Swiper('.furnizori-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
}

theme.collectionSort = function() {
  MicroModal.init({
    onShow: modal => console.info(`${modal.id} is shown`), // [1]
    onClose: modal => console.info(`${modal.id} is hidden`), // [2]
    openClass: 'is-open', // [5]
    disableScroll: true, // [6]
    disableFocus: false, // [7]
    awaitOpenAnimation: false, // [8]
    awaitCloseAnimation: true, // [9]
    debugMode: true // [10]
  });

  $('body').on('click tap', '.sort-by-box li.sort-action', function(){
    console.log("Clicked");
    if(!$(this).hasClass('active')){
      $('body').addClass('sorting');
      MicroModal.close('collection-sort-modal');
    }
  });
  console.log("Sort By", theme.sortBy);
  if (theme.sortBy === 'title-ascending') {
    $('.btn-sort span:last-child').html('Nume, A-Z');
  }
  if (theme.sortBy === 'title-descending') {
    $('.btn-sort span:last-child').html('Nume, Z-A');
  }
  if (theme.sortBy === 'manual') {
    $('.btn-sort span:last-child').html('Recomandate');
  }
  if (theme.sortBy === 'price-ascending') {
    $('.btn-sort span:last-child').html('Preţ ascendent');
  }
  if (theme.sortBy === 'price-descending') {
    $('.btn-sort span:last-child').html('Preţ descendent');
  }
  if (theme.sortBy === 'created-ascending') {
    $('.btn-sort span:last-child').html('Cele mai vechi');
  }
  if (theme.sortBy === 'created-descending') {
    $('.btn-sort span:last-child').html('Cele mai noi');
  }
  if (theme.sortBy === 'best-selling') {
    $('.btn-sort span:last-child').html('Populare');
  }

  var canviLeft = new Canvi({
    content: '.canvi-content',
    navbar: '.collection-mobile-filter',
    openButton: '.open-collection-mobile-filter',
    pushContent: false
  });
}

theme.product = function() {
  $('.product-images').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Se incarca imaginea #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      }
  });
  var swiper = new Swiper('.product-images-thumbs', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    slidesPerGroup: 1,
    grabCursor: true,
    centeredSlides: false,
    passiveListeners: false,
    lazy: true,
    autoHeight: true,
    scrollbar: {
      el: '.scrollbar',
      hide: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 640px
      992: {
        allowTouchMove: false,
        preventClicksPropagation: false,
        preventClicks: false,
        autoHeight: false,
        grabCursor: false,
        centeredSlides: false,
        centerInsufficientSlides: true,
        normalizeSlideIndex: true,
        slidesPerView: 4,
      }
    }
  });

  $('body').on('click tap', '.product-images-thumbs .slide', function(event) {
    if (event.target.attributes['data-image'] != undefined) {
      console.log('Event', event.target.attributes['data-image'], event);
      //swiper.slideTo(parseInt(event.target.attributes['data-index']), 1000, false );
      $('.product-featured-image img').removeAttr('data-srcset').removeAttr('srcset');
      $('.product-featured-image img').attr('src', event.target.attributes['data-image'].value);
    }
  });

  var related = new Swiper('.related-products-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });
  var asociate = new Swiper('.produse-asociate-slideshow', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    lazy: true,
    passiveListeners: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.scrollbar',
      hide: false,
    },
  });

  //Product Navigation
  var t,
    i = $("#product-navigation-list"),
    a = i.outerHeight(),
    n = i.find("a"),
    o = n.map(function() {
      var t = $($(this).attr("href"));
      if (t.length) return t;
    });
  n.on('click tap', function(t) {
    var i = $(this).attr("href"),
    n = "#" === i ? 0 : $(i).offset().top - a - 40;
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: n
        },
        850
      ),
      t.preventDefault();
  }),
  $(window).scroll(function() {
    var i = $(this).scrollTop() + a + 44,
      r = o.map(function() {
        if ($(this).offset().top < i) return this;
      }),
      s = (r = r[r.length - 1]) && r.length ? r[0].id : "";
    t !== s &&
      ((t = s),
      n
        .parent()
        .removeClass("active")
        .end()
        .filter("[href='#" + s + "']")
        .parent()
        .addClass("active"));
  });

  $('.go-to-reviews').on('click tap', function(t) {
    var i = $(this).attr("href"),
    n = "#" === i ? 0 : $(i).offset().top - a - 40;
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: n
        },
        850
      ),
      t.preventDefault();
  });

  $(".vezi-part").on("click", function(e) {
    e.preventDefault();
    var i = $(this).data("vezi");
    $(i)
      .css("height", "auto")
      .removeClass("closed"),
      $(this).remove();
  });
}

theme.quickProduct = function() {
  if ($('.main-product .js-product-form').length > 0) {
    $(window).on('scroll', function() {
      var top_of_screen = $(window).scrollTop();
      var $quickProduct = $(".quick-product");
      var top_of_element = $(".main-product .js-product-form").offset().top;
      var bottom_of_element = $(".main-product .js-product-form").offset().top + $(".main-product .js-product-form").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $quickProduct.removeClass("active");
      } else {
        $quickProduct.addClass("active");
      }
    });
  }

  var top_of_screen = $(window).scrollTop();
  var $quickProduct = $(".quick-product");

  if ($('.main-product .js-product-form').length > 0) {
    var top_of_element = $(".main-product .js-product-form").offset().top;
    var bottom_of_element = $(".main-product .js-product-form").offset().top + $(".main-product .js-product-form").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    if ($("body").hasClass('template-product') && top_of_screen > 300) {
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $quickProduct.removeClass("active");
      } else {
        $quickProduct.addClass("active");
      }
    }
  }
}

theme.addToCart = function() {
  var $form = $('.js-product-form');
  $form.on('submit', function(event) {
    event.preventDefault();
    var $form = $(this);
    var $addToCart = $form.find('.js-add-to-cart');
    let type = this.dataset.type;
    $addToCart.find('.spinner').css('opacity', 1);
    var id = $(this).find("[name='id']").val(),
        qty = $(this).find("#quantity").val() || 1;

        if (type == 'giftcard') {
          CartJS.addItem(id, qty, {
            "__shopify_send_gift_card_to_recipient": true,
              "Recipient email": "office@solaro.ro"
          },{
            "success": function(data, textStatus, jqXHR) {
              $addToCart.find('.spinner').css('opacity', 0);
              theme.cartDrawer.open();
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              $addToCart.find('.spinner').css('opacity', 0);
              alert("Lipsa Stoc!");
            }
          });
        } else {
          CartJS.addItem(id, qty, {
          },{
            "success": function(data, textStatus, jqXHR) {
              $addToCart.find('.spinner').css('opacity', 0);
              theme.cartDrawer.open();
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              $addToCart.find('.spinner').css('opacity', 0);
              alert("Lipsa Stoc!");
            }
          });
        }
  })
}

theme.cookies = function() {
  if (Cookies.get('AcceptCookies') === 'false') {
    $('#cookies-bar').show();
  }

  if (Cookies.get('AcceptCookies') === undefined) {
    Cookies.set('AcceptCookies', 'false');
    $('#cookies-bar').show();
  }

  $('body').on('click tap', '#accepta', function(e) {
    e.preventDefault();
    Cookies.set('AcceptCookies', 'true');
    $('#cookies-bar').remove();
  });
  $('body').on('click tap', '#cookies-close', function(e) {
    e.preventDefault();
    //Cookies.set('AcceptCookies', 'false');
    $('#cookies-bar').remove();
  });
}

theme.menuDrawer = function() {
  theme.menuDrawer = new Canvi({
    content: '.canvi-content',
    navbar: '.mobile-offcanvas-menu',
    openButton: '.toggle-mobile-menu',
    position: 'left',
    pushContent: false
  });
  $('body').on('click tap', '#menu .close-drawer', function(e){
    e.preventDefault();
    theme.menuDrawer.close();
  });
}